import { jsx as _jsx } from "react/jsx-runtime";
const ScreenContent = ({ children }) => _jsx("div", { className: "p-6", children: children });
export default ScreenContent;
